import { render, staticRenderFns } from "./sidebar-news.vue?vue&type=template&id=5dbb37da&"
import script from "./sidebar-news.vue?vue&type=script&lang=js&"
export * from "./sidebar-news.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports